import { GroupListScreenNavigationProps } from "./types"
import React from "react"
import GroupList from "./group-list-screen"
import { PageRoot } from "~screens/page-root"


const GroupListScreen: React.FC<GroupListScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <GroupList />
    </PageRoot>
  )
}

export default GroupListScreen
